import React from "react";
import styled from "styled-components";
import ListItem from "./ListItem";
import { DragDropContext, Droppable } from "react-beautiful-dnd";
import { Draggable } from "react-beautiful-dnd";

const ListContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 30px;
  width: 45%;
  box-shadow: 0 0 2rem 0.4rem hsl(0, 0%, 0%, 0.1);

  @media (max-width: 600px) {
    width: 90%;
  }
`;

const Wrapper = styled.ul`
  display: flex;
  flex-direction: column;
  list-style: none;
  width: 100%;
`;

const Footer = styled.div`
  /* display: flex;
  justify-content: space-between;
  align-items: center; */
  display: grid;
  grid-template-columns: 130px 1fr 0.7fr;
  background-color: ${(props) => props.theme["clr-card-bg"]};
  padding: 10px;
  border-radius: 0 0 0.5rem 0.5rem;

  @media (max-width: 600px) {
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr 1fr;
    gap: 5rem 2rem;
  }
`;

const FooterItem = styled.span`
  cursor: pointer;
  font-size: 16px;
  color: ${(props) => props.theme["clr-gb-4"]};
  width: max-content;
  margin-left: 20px;

  &:hover {
    color: ${(props) => props.theme["clr-primary"]};
  }

  @media (max-width: 600px) {
    font-size: 14px;
  }
`;

const FilterContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media (max-width: 600px) {
    position: relative;
    grid-row: 2/3;
    grid-column: 1/3;
    justify-content: space-around;

    &::before {
      content: "";
      position: absolute;
      width: calc(100% + 4rem);
      height: 1rem;
      background-color: ${(props) => props.theme["clr-page-bg"]};
      top: -3rem;
    }
  }
`;

const FilterItem = styled.span`
  color: ${(props) =>
    props.filter ? "hsl(220, 98%, 61%)" : props.theme["clr-gb-4"]};
  font-size: 16px;
  font-weight: 400;
  cursor: pointer;
  margin-right: 10px;

  @media (max-width: 600px) {
    font-size: 14px;
  }

  &:hover {
    color: ${(props) => props.theme["clr-primary"]};
  }

  &.active {
    color: hsl(220, 98%, 61%) !important;
  }
`;

const List = ({
  items,
  toggleCheckBox,
  clearAllTodos,
  deleteTask,
  filter,
  setFilter,
  handleOnDragEnd,
}) => {
  return (
    <ListContainer>
      <DragDropContext onDragEnd={handleOnDragEnd}>
        <Droppable droppableId="tasks">
          {(provided) => (
            <Wrapper {...provided.droppableProps} ref={provided.innerRef}>
              {items.map((item, index) => (
                <Draggable key={item.id} draggableId={item.id} index={index}>
                  {(provided) => (
                    <ListItem
                      draggableRef={provided.innerRef}
                      draggableProps={provided.draggableProps}
                      dragHandleProps={provided.dragHandleProps}
                      key={item.id}
                      data={item}
                      toggleCheckBox={toggleCheckBox}
                      deleteTask={deleteTask}
                    />
                  )}
                </Draggable>
              ))}
              {provided.placeholder}
            </Wrapper>
          )}
        </Droppable>
      </DragDropContext>
      <Footer>
        <FooterItem style={{ cursor: "default" }}>
          {items.length} items left
        </FooterItem>
        <FilterContainer>
          <FilterItem
            filter={filter === "all"}
            onClick={() => setFilter("all")}
          >
            All
          </FilterItem>
          <FilterItem
            filter={filter === "active"}
            onClick={() => setFilter("active")}
          >
            Active
          </FilterItem>
          <FilterItem
            filter={filter === "completed"}
            onClick={() => setFilter("completed")}
          >
            Completed
          </FilterItem>
        </FilterContainer>
        <FooterItem onClick={clearAllTodos}>Clear Completed</FooterItem>
      </Footer>
    </ListContainer>
  );
};

export default List;
